const Footer = () => {
  return (
    <footer className="w-full bg-black text-white px-2 md:px-8">
      <div className="max-w-[1500px] mx-auto px-4 md:px-12 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} Matteo Aries
          </p>
          <div className="flex items-center gap-6">
            <a
              href="mailto:ariesmatteo@gmail.com"
              className="text-sm font-bold text-gray-400 hover:text-orange-500 transition-colors"
            >
              Email
            </a>
            <a
              href="https://www.linkedin.com/in/ariesmatteo/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-bold text-gray-400 hover:text-orange-500 transition-colors"
            >
              LinkedIn
            </a>
            <a
              href="https://github.com/Smagia"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-bold text-gray-400 hover:text-orange-500 transition-colors"
            >
              GitHub
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
